import axiosClient from '../api/axiosClient';
import API from '../Constants/apiRoutes';

/**
 * PUBLIC onboarding endpoints. These are called from the unauthenticated
 * /onboarding/{token} route and do NOT use an Administration Bearer token
 * (the axios interceptor simply attaches nothing when no token is stored).
 */
const onboardingService = {
  /** GET /onboarding/industries -> [{ id, code, name }]. */
  getIndustries: async () => {
    const { data } = await axiosClient.get(API.onboarding.industries);
    return data;
  },

  /** GET /onboarding/forms/{token} -> invitation info; 404 => invalid/expired link. */
  getForm: async (token) => {
    const { data } = await axiosClient.get(API.onboarding.form(token));
    return data;
  },

  /** POST /onboarding/forms/{token} -> submit organization profile + three contacts. */
  submitForm: async (token, payload) => {
    const { data } = await axiosClient.post(API.onboarding.form(token), payload);
    return data;
  },
};

export default onboardingService;
